var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"callback-loading"},[_c('div',{staticClass:"cssload-container"},[_c('div',{staticClass:"cssload-whirlpool"})])])])}]

export { render, staticRenderFns }